<template>
  <div class="carouselMain">
    <div class="carouselSeach">
      <el-input :placeholder="this.bottom.searchPlaceholder" v-model="searchValue" @change="query">
        <el-button slot="append" type="danger" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <!-- <div class="lineMain">
            <i style="width:70%"></i>
                {{this.carouselIndex}} / {{ this.carouselDate.length }}
            <i style="width:10%"></i>
        </div> -->
    <el-carousel arrow="always" @change="carouselChange">
      <el-carousel-item v-for="(item, index) in carouselDate" :key="index">
        <div @click="handleClick(item)" class="carouselImg">
          <!-- <img ref="bannerHeight" :src="item.imgUrl" :alt="item.imgAlt"/> -->
          <el-image :src="item.imgUrl" :alt="item.imgAlt" fit="cover"></el-image>
          <h3 v-if="item.title && item.title.length > 0">{{ item.title }}</h3>
        </div>
      </el-carousel-item>
      <img :src="carouselImg[0].imgUrl" class="carouselDateImg" alt="" />
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    val: {},
  },
  data() {
    return {
      carouselDate: [],
      carouselIndex: '1',
      searchValue: '',
      bottom: {},
      carouselImg: [
        {
          imgUrl: '',
        },
      ],
    }
  },
  created() {
    this.getData()
    // this.bottom = JSON.parse(localStorage.getItem('bottom'))
    this.bottom = this.$store.getters.bottom
  },
  methods: {
    handleClick(row) {
      if (row.linkUrl) {
        window.open(row.linkUrl, '_self')
      }
    },
    getData() {
      this.carouselDate = this.val.attaches || []
      this.carouselImg = this.carouselDate
    },
    carouselChange(index) {
      this.carouselIndex = index + 1
    },
    // 搜索
    query() {
      this.$router.push({
        name: 'SEARCHLIST',
        query: { languageId: this.$route.query.languageId, searchValue: this.searchValue },
      })
    },
  },
  watch: {
    val(val) {
      this.getData()
    },
  },
}
</script>
<style scoped lang="less">
.carouselMain {
  position: relative;
  width: 100%;
  height: auto;
  display: table;
  // background:#f2f2f2;
  .carouselSeach {
    display: none;
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 11;
    overflow: hidden;
    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }
    /deep/ .el-input-group__append {
      background-color: #d11a2e;
      color: #fff;
      padding: 6px 10px;
    }
  }
  /deep/.el-carousel__container {
    height: auto;
  }
  .carouselDateImg {
    width: 100%;
    min-height: 270px;
    height: auto;
    max-height: 650px;
    opacity: 0;
  }
  .carouselImg {
    cursor: pointer;
    /deep/.el-image {
      width: 100%;
      height: 100%;
      img {
        min-height: 200px;
        height: auto;
        width: 100%;
        display: block;
      }
    }
    h3 {
      width: 100%;
      height: auto;
      line-height: 26px;
      text-align: center;
      background: #f2f2f2;
      color: #000;
      position: relative;
      bottom: 0;
      margin: 0;
      padding: 10px 20px;
      box-sizing: border-box;
      font-size: 16px;
      margin: -4px 0 0;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  /deep/.el-carousel__indicators--horizontal {
    bottom: 40px;
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 4px;
    }
  }
  .lineMain {
    display: none;
    position: absolute;
    left: 120px;
    width: 60%;
    height: 40px;
    line-height: 40px;
    bottom: 50px;
    z-index: 11;
    color: #fff;
    text-align: left;
    i {
      margin-bottom: 5px;
      border-bottom: 1px solid #fff;
      display: inline-block;
    }
  }
  @media (max-width: 768px) {
    .carouselDateImg {
      min-height: 200px;
    }
    /deep/.el-carousel__indicators--horizontal {
      bottom: 37px;
    }
    .carouselImg {
      h3 {
        height: 40px;
        background: rgba(255, 255, 255, 0.6);
        position: absolute;
        bottom: 3px;
        margin: 0;
        line-height: 40px;
        font-size: 18px;
        padding: 0;
        overflow: hidden; /*隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /* 超出部分省略号 */
      }
    }
  }
  @media (min-width: 768px) {
    .carouselSeach {
      display: block;
      position: absolute;
      top: 10px;
      right: 20px;
      z-index: 11;
    }
    .carouselImg {
      h3 {
        height: 40px;
        background: rgba(255, 255, 255, 0.6);
        position: absolute;
        bottom: 0;
        margin: 0;
        line-height: 40px;
        font-size: 18px;
        padding: 0;
        overflow: hidden; /*隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /* 超出部分省略号 */
      }
    }
    .lineMain {
      display: block;
      left: 150px;
      bottom: 50px;
      width: 80%;
    }
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    .lineMain {
      left: 150px;
      bottom: 50px;
      width: 80%;
    }
  }
  @media (min-width: 1200px) {
    .lineMain {
      left: 200px;
      width: 80%;
      bottom: 100px;
      display: block;
      i {
        margin-bottom: 5px;
        border-bottom: 1px solid #fff;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch1.vue